import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CellRenderer, Column } from '@miq/catalog';
import { PropertySetsDialogActionsComponent } from '../../../property-sets-dialog-actions/property-sets-dialog-actions.component';

@Component({
  selector: 'miq-open-in-new-renderer, [miqOpenInNewRenderer]',
  template: `
    <div
      class="fx--h fx--juc-start fx--ali-center"
      [matTooltip]="'Open Record in a new tab'"
      matTooltipPosition="above"
      matTooltipClass="tooltip-action-icon"
    >
      <mat-icon class="icon go-to-record" (click)="openInNewTab()">open_in_new</mat-icon>
    </div>
  `,
  styleUrls: ['./open-in-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OpenInNewComponent implements CellRenderer<Column> {
  public data?: Record<string, any> = null;
  public config?: Column;

  constructor(public dialogRef: MatDialogRef<PropertySetsDialogActionsComponent>) {}

  openInNewTab() {
    window.open(`/records/property/${this.data?.entity.id}/edit`, '_blank');
  }

  render(): void {
    // required by CellRenderer
  }
}
